import {
  SET_FOOD_CART,
  UPDATE_FOOD_LIST_CART,
  CALCULATTING_CART,
  EMPTY_CART,
  FINAL_SUBMIT_CART,
  RESET_FOOD_CART,
  SET_EDIT_MODE_CART,
  CHANGE_ADDRESS_CART,
  RESET_CART,
} from "./actionTypes";

const initialState = {
  finalSubmit: false,
  list: null,
  totalPrice: 0,
  subside: 0,
  totalPriceWithCalcSubside: 0,
  paidPrice: 0,
  totalQuantity: 0,
  calculatting: true,
  companyAddressId: 0,
  companyAddressFloorId: 0,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_FOOD_CART: {
      return {
        ...state,
        ...payload,
        calculatting: false,
      };
    }
    case UPDATE_FOOD_LIST_CART: {
      return {
        ...state,
        list: payload,
        calculatting:
          payload?.calculatting == undefined ? true : payload.calculatting,
      };
    }
    case CALCULATTING_CART: {
      return {
        ...state,
        calculatting: payload,
      };
    }
    case FINAL_SUBMIT_CART: {
      return {
        ...state,
        ...payload,
        finalSubmit: true,
        editMode: false,
        paidPrice: state.totalPriceWithCalcSubside,
      };
    }
    case SET_EDIT_MODE_CART: {
      return {
        ...state,
        editMode: payload,
      };
    }
    case EMPTY_CART: {
      return {
        ...initialState,
        list: [],
        calculatting: false,
      };
    }
    case RESET_FOOD_CART: {
      return { ...initialState, calculatting: false };
    }
    case CHANGE_ADDRESS_CART: {
      return {
        ...state,
        companyAddressId: payload.addressId,
        companyAddressFloorId: payload.floorId || 0,
      };
    }
    case RESET_CART: {
      return initialState;
    }
    default:
      return state;
  }
};
